import { tv } from '@/common/theme/tv.config';

export const styles = {
  host: tv({
    base: 'relative right-0 w-[100%] rounded-md border p-md shadow-hovering-neutral10 md:w-[36rem] md:rounded-xl md:p-lg',
    variants: {
      type: {
        success: 'border-systemSuccess bg-systemSuccess10',
        error: 'border-systemError bg-systemError10',
        warning: 'border-systemWarning bg-systemWarning10',
      },
    },
  }),
  content: 'flex-wrap flex-row',
  close: 'absolute text-semantic-text-neutral20 cursor-pointer',
};
